import type { BreadCrumbDetails } from '@shared/components';
import { APPOINTMENT_MAKE_NEW_BOOK_POLYCLINIC_PATH, APPOINTMENT_PATH } from '@shared/constants/paths';

const MAKE_NEW_BREADCRUMBS: BreadCrumbDetails[] = [
  {
    path: APPOINTMENT_PATH,
    title: 'Appointments',
  },
  {
    path: APPOINTMENT_MAKE_NEW_BOOK_POLYCLINIC_PATH,
    title: 'New Appointment',
  },
];

export const MAMMOGRAM_QUESTION_NRIC_ID = 'MMG-Q001';

export const MAMMOGRAM_QUESTION_NAME_ID = 'MMG-Q004';

export const MAMMOGRAM_QUESTION_EMAIL_ADDRESS_IDS = ['MMG-Q006', 'MMG-Q006-1'];

export const MAMMOGRAM_QUESTION_CONTACT_NUMBER_IDS = ['MMG-Q005', 'MMG-Q005-1'];

export const MAMMOGRAM_QUESTION_APPOINTMENT_TYPE_ID = 'MMG-Q007';

export const MAMMOGRAM_QUESTION_YEAR_BREAST_CANCER = 'MMG-Q010-2';

export const MAMMOGRAM_QUESTION_DIAGNOSIS_ID = 'MMG-Q010-3';

export const MAMMOGRAM_QUESTION_YEAR_DISCHARGED = 'MMG-Q010-5';

export const MAMMOGRAM_QUESTION_DISCHARGED_ID = 'MMG-Q010-4';

export const MAMMOGRAM_QUESTION_COVID_DATE_ID = 'MMG-Q012-01';

export const MAMMOGRAM_QUESTION_CONSENT_ID = 'MMG-Q100';

export { MAKE_NEW_BREADCRUMBS };

export const PAYMENT_OPTIONS = [
  {
    desc: '(Payment due will be sent to your Health Buddy notifications inbox or SMS)',
    label: 'Credit Card / eNets on Health Buddy',
    value: 'Credit Card / eNets on Health Buddy',
  },
  {
    label: 'SPEEDPAY (if already signed up)',
    value: 'SPEEDPAY (if already signed up)',
  },
  {
    label: 'Civil Service Card (CSC) Holder*',
    value: 'Civil Service Card (CSC) Holder',
  },
  {
    label: 'SingHealth Staff Benefit Card*',
    value: 'SingHealth Staff Benefit Card',
  },
];

export const POSTAL_CODE_VALID_LENGTH = 6;

export const SLOT_MSG_CODE_NSC = 'Appointment.Message.SlotHelpInfo.NSC';

export const FV_SPECIALTY_TYPES_CODE = 'Appointments.Institutions.FvSpecialtyTypes';
export const SH_LOGO_CODE = 'SHP';

export const TELECONSULT_CATEGORY_CODES = ['CVD', 'SOC'] as const;

export const KK_TELEPAEDS_SERVICE_TYPE_CODE = '1173000009';

export const OTHERS_PATTERN = /\(others\)/i;
export const OTHERS_SORT_REPLACEMENT = '￿';
